import { userTempInventoryState } from './userTempInventoryState';

export function disconnectUserTempInventory(): void {
  userTempInventoryState.userId = null;
  userTempInventoryState.files = [];
  userTempInventoryState.ready = false;
  userTempInventoryState.loading = false;
}
